import { Injectable } from '@angular/core'
import { filterNilValue, QueryEntity } from '@datorama/akita'
import type { Observable } from 'rxjs'
import { filter, map } from 'rxjs/operators'
import type { Ahu, AhuResults } from './ahu.model'
import { AhuStore, AhuState } from './ahu.store'

@Injectable({ providedIn: 'root' })
export class AhuQuery extends QueryEntity<AhuState, Ahu> {
  constructor(protected store: AhuStore) {
    super(store)
  }

  isValid$ = this.select(state => state.ui.formState.isValid)

  canSave$ = this.select(state => state.ui.formState.isModified && state.ui.formState.isValid)

  isModified$ = this.select(state => state.ui.formState.isModified)

  get isModified() {
    return this.getValue().ui.formState.isModified
  }

  get isValid() {
    return this.getValue().ui.formState.isValid
  }

  hasAhu(id: string): boolean {
    return this.hasEntity(id) && this.getHasCache()
  }

  selectAhu(id: string): Observable<Ahu> {
    return this.selectEntity(id).pipe(filterNilValue())
  }

  hasResults(id: string): boolean {
    return this.hasEntity(id) && !!this.getEntity(id).Results
  }

  selectResults(id: string): Observable<AhuResults> {
    return this.selectEntity(id).pipe(
      filterNilValue(),
      filter(({ Results }) => !!Results),
      map(ahu => ahu.Results),
    )
  }
}
